import type { PerformanceDatapoint } from 'owa-analytics';

const API_MODEL = 'B2';
const API_TYPE = 'GraphQL';

export const addB2CustomData = (dataPoint: PerformanceDatapoint | null | undefined): void => {
    dataPoint?.addCustomData({
        apiModel: API_MODEL,
        apiType: API_TYPE,
    });
};
